import React, { useState } from 'react';
import { apiCall } from '../utils/api';

export default function CalendarForm({ onEventCreated }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [date, setDate] = useState('');
  const [type, setType] = useState('milestone');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!title.trim()) {
      setError('Event title is required');
      return;
    }

    if (!date) {
      setError('Date is required');
      return;
    }

    setLoading(true);

    try {
      const newEvent = await apiCall('/api/calendar', {
        method: 'POST',
        body: JSON.stringify({
          title,
          description,
          date,
          type,
        }),
      });

      onEventCreated(newEvent);
      setTitle('');
      setDescription('');
      setDate('');
      setType('milestone');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="calendar-form">
      <div className="form-group">
        <label htmlFor="title">Event title *</label>
        <input
          id="title"
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="e.g., Track opening day"
          disabled={loading}
        />
      </div>

      <div className="form-group">
        <label htmlFor="description">Description</label>
        <textarea
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Optional details"
          rows="2"
          disabled={loading}
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="date">Date *</label>
          <input
            id="date"
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="type">Type</label>
          <select
            id="type"
            value={type}
            onChange={(e) => setType(e.target.value)}
            disabled={loading}
          >
            <option value="milestone">Milestone</option>
            <option value="decision">Decision</option>
            <option value="meeting">Meeting</option>
          </select>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      <button type="submit" disabled={loading} className="btn-primary">
        {loading ? 'Adding...' : 'Add event'}
      </button>
    </form>
  );
}
